module.exports = __webpack_public_path__ + "img/backTop.eff0d5d1.svg";